import LoginPage from "../pages/Login";
import SignupPage from "../pages/SignupPage";
import ActivationPage from "../pages/ActivationPage";
import HomePage from "../pages/HomePage";
import ProductsPage from "../pages/ProductsPage";
import BestSellingPage from "../pages/BestSellingPage";
import EventsPage from "../pages/EventsPage";
import FAQPage from "../pages/FAQPage";
import CheckoutPage from "../pages/CheckoutPage";
import PaymentPage from "../pages/PaymentPage";
import OrderSuccessPage from "../pages/OrderSuccessPage";
import ProductDetailsPage from "../pages/ProductDetailsPage";
import ProfilePage from "../pages/ProfilePage";
import ShopCreatePage from "../pages/ShopCreate";
import SellerActivationPage from "../pages/SellerActivationPage";
import ShopLoginPage from "../pages/ShopLoginPage";
import OrderDetailsPage from "../pages/OrderDetailsPage";
import TrackOrderPage from "../pages/TrackOrderPage";
import UserInbox from "../pages/UserInbox.jsx";

export { 
    LoginPage,
    SignupPage,
    ActivationPage,
    HomePage,
    ProductsPage,
    BestSellingPage,
    EventsPage,
    FAQPage,
    CheckoutPage,
    PaymentPage,
    OrderSuccessPage,
    ProductDetailsPage,
    ProfilePage,
    ShopCreatePage,
    SellerActivationPage,
    ShopLoginPage,
    OrderDetailsPage,
    TrackOrderPage,
    UserInbox
};